import * as Accordion from '@radix-ui/react-accordion'

import SvgIcon from '@/components/svg-icon/svgIcon'
import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { translate } from '@/utils/translator'

import { useRoomContext } from '../hooks/useRoomContext'
import { RoomPicker } from './room-picker'
import { RoomSummary } from './roomSummary'

type RoomStateSwitcherProps = {
	isSingleItem?: boolean
}

export const RoomStateSwitcher = ({ isSingleItem = false }: RoomStateSwitcherProps) => {
	const { isEditMode, roomConfig, roomNumber } = useRoomContext()
	const { selectedRooms } = useCartStore.use.roomSelection()

	const isRoomSelected = selectedRooms.find((sr) => sr.roomConfigId === roomConfig.id)

	const showSummary = isRoomSelected && !isEditMode

	return (
		<Accordion.Item
			value={roomConfig.id}
			className={cn(
				'flex flex-col gap-24 border-t  border-textColor py-24 text-naturel md:border-accent-5'
			)}
		>
			<Accordion.Header>
				{isSingleItem ? (
					<div>
						<div className="group flex w-full justify-between text-textColor">
							<Typography
								style="p-m-bold"
								element="p"
							>{`${translate('room-selection-room')} ${roomNumber}`}</Typography>
						</div>
					</div>
				) : (
					<Accordion.Trigger className="group flex w-full justify-between text-textColor">
						<Typography
							style="p-m-bold"
							element="p"
						>{`${translate('room-selection-room')} ${roomNumber}`}</Typography>
						<SvgIcon
							collectionName="ibe3"
							iconName="chevron"
							className="h-24 w-24 transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=closed]:rotate-180"
						/>
					</Accordion.Trigger>
				)}
			</Accordion.Header>
			<Accordion.Content className="overflow-hidden data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown">
				{showSummary ? (
					<div className={cn('md:w-1/2 lg:w-1/4')}>
						<RoomSummary room={isRoomSelected.room} hasEditMode />
					</div>
				) : (
					<RoomPicker />
				)}
			</Accordion.Content>
		</Accordion.Item>
	)
}
